import { storage } from '../platform/storage';

export type PolishSpeechProgress = {
  chapterId: string;
  paragraphId: string;
  queuePosition: number;
};

const progressKey = (gameId: string) => `@planszowki/polish-speech-progress/${gameId}`;

export function isPolishSpeechProgress(value: unknown): value is PolishSpeechProgress {
  if (!value || typeof value !== 'object') return false;
  const parsed = value as Partial<PolishSpeechProgress>;
  return (
    typeof parsed.chapterId === 'string' &&
    typeof parsed.paragraphId === 'string' &&
    typeof parsed.queuePosition === 'number' &&
    Number.isInteger(parsed.queuePosition) &&
    parsed.queuePosition >= 0
  );
}

export async function loadPolishSpeechProgress(
  gameId: string
): Promise<PolishSpeechProgress | null> {
  try {
    const value = await storage.getItem(progressKey(gameId));
    if (!value) return null;
    const parsed: unknown = JSON.parse(value);
    return isPolishSpeechProgress(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export async function savePolishSpeechProgress(
  gameId: string,
  progress: PolishSpeechProgress
): Promise<void> {
  await storage.setItem(progressKey(gameId), JSON.stringify(progress));
}

export async function clearPolishSpeechProgress(gameId: string): Promise<void> {
  await storage.removeItem(progressKey(gameId));
}
